import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as rolesUtils from '@app/role.utils';
import { WebsocketService } from '@app/services/websocket.service';
import { Store, select } from '@ngrx/store';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';
import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

import * as FileActions from '@core/actions/file.actions';
import * as packagingActions from '@core/actions/packaging.actions';
import * as ProformaActions from '@core/actions/proforma.actions';
import * as ReportsActions from '@core/actions/reports.actions';

import * as fromPackaging from '@core/reducers/packaging.reducer';
import * as fromProforma from '@core/reducers/proforma.reducer';
import * as fromReports from "@core/reducers/reports.reducer";
import * as fromRoot from '@core/reducers/root.reducer';

@Component({
    selector: 'app-supplier-portal-page',
    templateUrl: './supplier-portal-page.component.html',
    styleUrls: ['./supplier-portal-page.component.css']
  })

export class SupplierPortalPage implements OnInit {
    constructor(
      private ngProgress: NgProgress,
      private store: Store<any>,
      private ws: WebsocketService,
      private route: ActivatedRoute,
    ){}

    me$ = this.store.pipe(select(fromRoot.getMePopulated));
    getBusy$ = this.store.pipe(select(fromProforma.getBusy))
    getReportBusy$ = this.store.pipe(select(fromReports.getIsBusy));
    enrichData$ = this.store.pipe(select(fromProforma.getEnrichProductsInfo));
    supplierFileInfo$ = this.store.pipe(select(fromProforma.getSupplierFileinfo));
    isLoading$ = this.store.pipe(select(fromPackaging.getIsLoading))
    message$ = this.store.pipe(select(fromPackaging.geSpinnertMessage))

    progressRef: NgProgressRef
    _alive = true;
    followId;
    files = [];
    me;
    enrichData;
    discrepancies;
    packagings;
    proformasByProvider;
    currentProviderFilter = null;
    currentFollowFilter = null;
    currentN2Filter = null;

    get isProductManager(){
      return this.me && this.me.role && rolesUtils.isProductManager(this.me.role);
    }

    get isMerchant(){
      return this.me && this.me.role && rolesUtils.isMerchant(this.me.role);
    }

    get isSupplier(){
      return this.me && this.me.role && rolesUtils.isSupplier(this.me.role);
    }

    ngOnInit() {
      this.progressRef = this.ngProgress.ref();

      this.route.params.pipe(takeWhile(() => this._alive)).subscribe(params => {
        this.followId = params.FollowId;
      });

      this.me$.pipe(takeWhile(() => this._alive)).subscribe(me => {
        if (me && me.id) {
          this.me = me
          if(this.me.role === 'supplier'){
            this.store.dispatch(new ProformaActions.AllEnrichProducts({ SupplierId: this.me.ProviderId }))
          }else{
            this.store.dispatch(new ProformaActions.SupplierFile(this.followId))
            this.store.dispatch(new ProformaActions.AllEnrichProducts({ FollowId: this.followId }))
          }
        }
      });
      this.addData()
    }

    addData(){
      combineLatest(
        this.enrichData$,
      ).pipe(takeWhile(() => this._alive))
      .subscribe(([productsFood]: any) => {
        this.enrichData = (productsFood && productsFood.suppliers) || []
        this.proformasByProvider = (productsFood && productsFood.proformasByProvider) || []
        this.discrepancies = (productsFood && productsFood.discrepancies) || []
        this.packagings = (productsFood && productsFood.packagingsInfo) || []
      })

      this.supplierFileInfo$.pipe(takeWhile(()=> this._alive)).subscribe((s) => {
        if(s){
          this.files = s
        }
      })
    }

    changeFilter(e){
      combineLatest(
        this.enrichData$,
      ).pipe(takeWhile(() => this._alive))
      .subscribe(([productsFood]: any) => {
        let aux = (productsFood && productsFood.suppliers) || []
        let aux2 = (productsFood && productsFood.proformasByProvider) || []
        let aux3 = (productsFood && productsFood.discrepancies) || []
        let aux4 = (productsFood && productsFood.packagingsInfo) || []

        if(e.type === 'Supplier'){
          this.currentProviderFilter = parseInt(e.e.target.value)
        }
        if(e.type === 'Follow'){
          this.currentFollowFilter = parseInt(e.e.target.value)
        }
        if(e.type === 'N2'){
          this.currentN2Filter = parseInt(e.e.target.value)
        }

        if(this.currentProviderFilter){
          aux = aux.filter((a) => a.id === this.currentProviderFilter)
        }

        if(this.currentFollowFilter){
          aux = aux.filter((a) => a.FollowId === this.currentFollowFilter)
          aux2 = aux2.filter((a) => a.FollowId === this.currentFollowFilter)
        }

        if(this.currentN2Filter){
          aux = aux.filter((a) => a.n2Id === this.currentN2Filter)
        }

        this.enrichData = aux
        this.proformasByProvider = aux2
        this.discrepancies = aux3
        this.packagings = aux4
      })
    }

    downloadDiscrepancies(e){
      if(this.isSupplier){
        const RegionalId = e.proformas[0].BuyerId
        const OriginId = this.me.Provider.CountryId
        this.ws.exportDiscrepanciesId = Math.random().toString(36).slice(2)
        const filter = 'none'
        const type = undefined
        let filename = `Discrepancias-${this.me.Provider.name}.xlsx`;
        filename = filename.replace('&','amp')
        const parentId = e.ParentId
        const suppplierId = this.me.Provider.id
        this.store.dispatch(
          new ReportsActions.ExportPurchaseSummarySuplier(
            parentId,
            suppplierId,
            filename,
            type,
            filter,
            OriginId,
            RegionalId,
            this.ws.exportDiscrepanciesId
          )
        );
      }else{
        const filename = `Discrepancias.zip`;
        const filter = {
          enableShipment: 'onlyEnabled',
          selectedBuyer: e.currentPMSelected,
          selectedOrigin: e.currentOriginSelected
        }
        this.store.dispatch(
          new ReportsActions.ExportFollowDiscrepancies(
            this.followId,
            filename,
            filter
          ))
      }
    }

    downloadDiscrepanciesSuppliers(e){
      this.ws.exportDiscrepanciesId = Math.random().toString(36).slice(2)
      let filename = ''
      const filter = 'none'
      const type = undefined
      let OriginId = null
      let RegionalId = null
      let parentId = null
      let suppplierId = null
      if(this.isSupplier){
        filename = `Discrepancias-${this.me.Provider.name}.xlsx`;
        filename = filename.replace('&','amp')
        OriginId = this.me.Provider.CountryId
        RegionalId = e.proformas[0].BuyerId
        parentId = e.ParentId
        suppplierId = this.me.Provider.id
      }else{
        filename = `Discrepancias-${e.sup.name}.xlsx`;
        filename = filename.replace('&','amp')
        parentId = e.e.ParentId
        suppplierId = e.sup.id
        OriginId = e.currentOriginSelected
        RegionalId = this.me && this.me.role === "merchant" ? e.currentPMSelected : this.me.id
      }
      this.store.dispatch(
        new ReportsActions.ExportPurchaseSummarySuplier(
          parentId,
          suppplierId,
          filename,
          type,
          filter,
          OriginId,
          RegionalId,
          this.ws.exportDiscrepanciesId
        )
      );
    }

    downloadEnrichProducts(e){
      this.store.dispatch(new ProformaActions.DownloadEnrichProducts(e))
    }

    uploadMassiveEnrich(e){
      this.store.dispatch(new ProformaActions.GetUploadLink(e, 'massiveEnrich'))
    }

    fileInputChange(event) {
      if (event.target.files) {
        const files = event.target.files;
  
        if (files && files[0]) {
          console.log(files[0],' - ',this.me.Provider)
  
          event.target.value = null;
        }
      }
    }

    uploadSupplierDiscrepanciess(e){
      if(this.me.Provider){
        this.store.dispatch(new ProformaActions.GetUploadLink(e.files, e.type, 
        { ParentId: e.ed.ParentId, SupplierId: this.me.Provider.id, 
          UserId: e.ed.proformas[0].BuyerId, OriginId: this.me.Provider.CountryId,
          observation: e.observation 
        }))
      }else{
        const OriginId = e.currentOriginSelected
        const RegionalId = this.me && this.me.role === "merchant" ? e.currentPMSelected : this.me.id
        this.store.dispatch(new ProformaActions.GetUploadLink(e.files, e.type, 
          { ParentId: e.ed.ParentId, SupplierId: e.sup.id, 
            UserId: RegionalId, OriginId: OriginId,
            observation: e.observation 
          }
        ))
      }
    }

    downloadPackaging(e){
      if(this.me.Provider){
        this.store.dispatch(new packagingActions.ExportPackaging(this.me.Provider.id, e.downloadMode, e.followId, e.packagingId, null, null, this.me.Provider.name))
      }else{
        this.store.dispatch(new packagingActions.ExportPackaging(e.suppplierInfo.id, e.downloadMode, e.followId, e.packagingId, null, null, e.suppplierInfo.name))
      }
    }

    uploadPackaging(e){
      this.store.dispatch(new packagingActions.ImportFile(e.file, e.packagingId, e.type));
    }

    downloadAllSuppliers(e){
      this.store.dispatch(new packagingActions.DownloadAllProviders(e))
    }

    uploadsMassive(e){
      this.store.dispatch(new packagingActions.ImportFile(e.file, e.packagingId, e.type));
    }

    downloadFile(e){
      this.store.dispatch(
        new FileActions.GenerateTempLink(
          e.currentFiles,
          e.fileName
        )
      )
    }

    supplierFile(e){
      this.store.dispatch(
        new ProformaActions.SupplierFileUpdate(e.currentFilesId, e.status, this.followId, e.type)
      )
    }

    changeFollowId(e){
      this.store.dispatch(new ProformaActions.SupplierFile(e))
      this.store.dispatch(new ProformaActions.AllEnrichProducts({ FollowId: e }))
      this.followId = e
      this.addData()
    }
}